import script from "./RcDropdownItemSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcDropdownItemSelect.vue?vue&type=script&setup=true&lang=ts"

import "./RcDropdownItemSelect.vue?vue&type=style&index=0&id=4bb18700&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bb18700"]])

export default __exports__